import { useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useEventEmitter, { emitEvent } from "../../../hooks/useEventEmitter";
import SideDrawer, { SideDrawerBody } from "../../../components/SideDrawer";
import InputText from "../../../components/InputText";

const CASE_TRANSCRIPT_DRAWER_EVENT = "CASE_TRANSCRIPT_DRAWER_EVENT";

export const toggleCaseTranscriptDrawer = (data?: string) => {
    emitEvent(CASE_TRANSCRIPT_DRAWER_EVENT, data);
};

const CaseTranscriptDrawer = () => {
    const { t } = useTranslation();

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [detail, setDetail] = useState<string>();
    const { control } = useForm();

    const onClose = useCallback(() => {
        setIsDrawerOpen(false);
    }, []);

    useEventEmitter(
        CASE_TRANSCRIPT_DRAWER_EVENT,
        (data?: string) => {
            setIsDrawerOpen((prev) => !prev);
            setDetail(data);
        }
    );

    return (
        <SideDrawer
            visible={isDrawerOpen}
            onClose={onClose}
            title={t("Edit_Voice_Note")}
        >
            <SideDrawerBody>
                {/* Content */}
                <InputText
                    control={control}
                    value={detail}
                    name="note"
                    label={t("Voice_Note_Text")}
                    multiline
                    rows={8}
                    fullWidth
                    autoFocus
                    isLabelDefaultBehaviour
                    sx={{ borderRadius: 1 }}
                />

            </SideDrawerBody>
        </SideDrawer>
    );
};

export default CaseTranscriptDrawer;
